import dayjs from 'dayjs';

export enum TermsType {
  // General
  General = 'General',

  // Product
  '2W' = '2W',
  '4W' = '4W',
  PBF = 'PBF',

  // Role
  SPV = 'SPV',
  BM = 'BM',
  ABPM = 'ABPM',
  AM = 'AM',
}

export const NO_VERSION_YET = '-';

/**
 * NOTE: hardcoded value to determine whether the new term has been read by the user or not
 * this is coming from the requirement
 */
export const CURRENT_TERMS_VERSION_MAP: Record<TermsType, string> = {
  // General
  [TermsType.General]: dayjs('13-Nov-2024').format('DD-MMM-YYYY'),

  // Product
  [TermsType['2W']]: NO_VERSION_YET,
  [TermsType['4W']]: NO_VERSION_YET,
  [TermsType.PBF]: NO_VERSION_YET,

  // Role
  [TermsType.SPV]: NO_VERSION_YET,
  [TermsType.BM]: NO_VERSION_YET,
  [TermsType.ABPM]: NO_VERSION_YET,
  [TermsType.AM]: NO_VERSION_YET,
};

export const termsUpdate = [
  { before: 'BA Active', after: 'BA Register' },
  { before: 'BA Visit', after: 'BA Maintain' },
  { before: 'BA Prospect', after: 'BA Active' },
  { before: 'First Meet', after: 'BA Recruit' },
];
